
export default {
    initState(state, stateObj) {
        state = stateObj;
        localStorage.setItem('state', JSON.stringify(state));
    },
    initCart(state, cart) {
        state.cart = cart;
        localStorage.setItem('state', JSON.stringify(state));
    },
    addGoods(state, params) {
        state.cart.push(params);
        localStorage.setItem('state', JSON.stringify(state));
    },
    reduceGoods(state, params) {

    },
    deleteGoods(state,params) {

    },
    selectGoods(state, goodsIndex) {
        console.log('mutations-selectGoods')
        alert('goodsIndex: ' + goodsIndex);
        state.cart[goodsIndex].checked = !state.cart[goodsIndex].checked;
        alert('checked: '+state.cart[goodsIndex].checked)
        state.cart[goodsIndex].checked ? ++state.cart[goodsIndex].selectedNum : --state.cart[goodsIndex].selectedNum;
        state.selectedNum === state.cart.length ? state.checkAllFlag = true : state.checkAllFlag = false
        state = Object.assign({}, state);
        console.log(state);
        localStorage.setItem('state', JSON.stringify(state));
    },
    checkAll(state, allFlag) {
        alert('allFlag: ' + allFlag);
        state.checkAllFlag = !state.checkAllFlag;
        state.cart.forEach(item => {
            if(state.checkAllFlag) {
                item.checked = true;
                state.selectedNum = state.cart.length;
            }
            else {
                item.checked = false;
                state.selectedNum = 0;
            }
        });
        alert('checkallflag: ' + state.checkAllFlag);
        localStorage.setItem('state', JSON.stringify(state));
    },
    toggleDelBtn(state, delFlag) {
        alert('toggleDelBtn' + state.delFlag)
        state.delFlag = !state.delFlag;
        alert('toggleDelBtn' + state.delFlag)
        localStorage.setItem('state', JSON.stringify(state));
    },
    delGoods(state) {
        let cart = state.cart
        state.cart = cart.filter(function(item) {
            return !item.checked
        })
        for(let i = 0, len = state.cart.length; i < len; i++) {
            state.cart[i].index = i;
        }
        state.selectedNum = 0;
        state.checkAllFlag = false;
        state.delFlag = !state.delFlag;
        localStorage.setItem('state', JSON.stringify(state));
    },
    initUser(state, user) {
        state.user = user;
        localStorage.setItem('state', JSON.stringify(state));
    },
    setUserTypeNum(state, typeNum) {
        state.userTypeNum = typeNum
        localStorage.setItem('state', JSON.stringify(state));
    },
    setPlayer(state, player) {
        state.player = player
        
    },
    setNewAddGoodsNum(state) {
        state.newAddGoodsNum++;
        localStorage.setItem('state', JSON.stringify(state));
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js